import DIV, { div } from '../../DOM/div/DIV.js';
/** An Vertical Flex DIV Element comprised of a Top, Middle and Bottom */
export default class FLEXVERTICAL extends DIV {
    top;
    middle;
    bottom;
    constructor(node, model) {
        super(node, model);
        this.addClass('flex-vertical');
        this.top = new DIV(this, div('flex-top'));
        this.middle = new DIV(this, div('flex-middle'));
        this.bottom = new DIV(this, div('flex-bottom'));
    }
}
